<template>
  <iframe type="text/html" style="width: 100%; min-height: 400px; height:100%; border: none;" src="https://www.vrtify.com/#/channel/p/3272?iframe=true" allowfullscreen></iframe>
</template>

<script>
export default {
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/vrtify/Vrtify.vue